import { Maskito } from './vendor/@maskito/core/index.esm.js';

export default (element) => {
    return new Maskito(element, {
        mask: /^[А-Яа-яЁё\-]+$/,
    });
}

